<template>
  <div class='content'>
    <headBox title="代投单"></headBox>
    <div class="top-search">
      <topSearchForm @search="search" :hiddenExport="true" :showSwtich="userinfo.level!=3&&orderForm.level==3">
        <el-form :inline="true" class="rform" :model="orderForm" ref="loginform">
          <el-form-item label="创建时间" class="small">
            <a-range-picker v-model="orderForm.dateTime" format="yyyy-MM-DD" valueFormat="yyyy-MM-DD  HH:mm:ss" separator="至">
              <i class="icon-riqixuanze" slot="suffixIcon"></i>
            </a-range-picker>
          </el-form-item>
          <el-form-item label="产品名称" class="small1">
            <el-input v-model="orderForm.productName" placeholder="请输入" clearable></el-input>
          </el-form-item>
          <el-form-item label="订单号" class="small1">
            <el-input type="text" v-model="orderForm.orderUniqueKey" placeholder="请输入" clearable></el-input>
          </el-form-item>
          <el-form-item label="">
            <div class="cell-border">
              <el-select class="left-select" v-model="orderForm.insuranceType" placeholder="请选择">
                <el-option label="投保人" value="1"></el-option>
                <el-option label="被保人" value="2"></el-option>
              </el-select>
              <el-input class="right-input" type="text" v-model="orderForm.name" placeholder="姓名/手机号" clearable></el-input>
            </div>
          </el-form-item>
          <el-form-item label="订单状态">
            <el-select class="only-select" placeholder="全部" v-model="orderForm.orderQueryStatus">
              <el-option label="全部" value="1"></el-option>
              <el-option label="未支付" value="2"></el-option>
              <el-option label="已支付" value="3"></el-option>
              <el-option label="已退款" value="4"></el-option>
              <el-option label="已关闭" value="5"></el-option>
              <el-option label="未核保" value="6"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="" v-if="!['2','3'].includes(userinfo.level)">
            <div class="cell-border">
              <el-select class="left-select" v-model="orderForm.level" @change="orderForm.orderSourceMechanId='';getChildList()" placeholder="出单机构">
                <el-option label="出单机构" value="2"></el-option>
                <el-option label="出单员工" value="3"></el-option>
              </el-select>
              <el-select class="right-select" v-model="orderForm.orderSourceMechanId" clearable filterable>
                <el-option :label="dept.shortName" :value="dept.id" v-for="(dept,index) in selectList" :key="index"></el-option>
              </el-select>
            </div>
          </el-form-item>
          <!-- 只有二级机构显示 -->
          <el-form-item label="出单员工" v-if="userinfo.level==2">
            <el-select v-model="orderForm.orderSourceMechanId" clearable filterable>
              <el-option :label="dept.shortName" :value="dept.id" v-for="(dept,index) in selectList" :key="index"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="所属部门" v-if="userinfo.level!=3&&orderForm.level==3">
            <el-cascader :options="deptList" v-model="orderForm.departmentId" :props="cascaderProps" :show-all-levels="false" filterable clearable></el-cascader>
          </el-form-item>
        </el-form>
      </topSearchForm>
      <div class="order-detail" v-if="userinfo.level==1">
        <el-tabs v-model="activeName" @tab-click="handlePaneClick">
          <el-tab-pane label="全部代投单" name="1"></el-tab-pane>
          <el-tab-pane label="我的代投单" name="2"></el-tab-pane>
          <el-tab-pane label="下级机构代投单" name="3" v-if="userinfo.isOpenMechanism==1"></el-tab-pane>
          <el-tab-pane label="员工代投单" name="4"></el-tab-pane>
        </el-tabs>
      </div>
      <div class="body-wrap" v-loading="loading">
        <!-- 录单列表 -->
        <div class="table-head table-row">
          <el-row :gutter="20">
            <el-col :span="4"><div>订单号</div></el-col>
            <el-col :span="3"><div>产品/险种名称</div></el-col>
            <el-col :span="3"><div>投/被保人</div></el-col>
            <el-col :span="3"><div>订单状态</div></el-col>
            <el-col :span="3"><div>保费（元）</div></el-col>
            <el-col :span="4"><div>创建时间</div></el-col>
            <el-col :span="4"><div>操作</div></el-col>
          </el-row>
        </div>
        <div v-for="(item, index) in orderList" :key="index">
          <div class="table-info" v-if="userinfo.level!=3">
            <div class="cd-mechan">
              <div class="mechan-info" v-if="['1','2'].includes(item.level)">
                <div class="left">出单机构：</div>
                <div class="right">{{ item.showName }}</div>
              </div>
              <div class="mechan-info" v-else>
                <div class="left">出单员工：</div>
                <div class="right">{{ item.showName }}</div>
              </div>
            </div>
          </div>
          <div class="card">
            <div class="table-row table-info1">
              <el-row :gutter="20">
                <el-col :span="4">
                  <tooltip :txt-info="item.orderId?item.orderId: item.orderNo | filterNull"></tooltip>
                </el-col>
                <el-col :span="3">
                  <tooltip :txt-info="item.productName | filterNull"></tooltip>
                </el-col>
                <el-col :span="3">
                  <tooltip :txt-info="fullName(item)"></tooltip>
                </el-col>
                <el-col :span="3">
                  <div v-if="!item.orderId">未核保</div>
                  <tooltip v-else :txt-info="item.orderStatus | filterOrderStatus"></tooltip>
                </el-col>
                <el-col :span="3">
                  <div>{{item.fee | filterNull}}</div>
                </el-col>
                <el-col :span="4">
                  <div>
                    {{item.createTime|timeSubstr(0,16)|filterNull}}
                  </div>
                </el-col>
                <el-col :span="4">
                  <div class="cz-list">
                    <el-button class="xq-btn" @click=" getDetail(item)" type="text">详情</el-button>
                    <el-button class="xq-btn" @click="copyPayUrl(item.payUrl)" type="text" v-if="item.orderStatus==1&&item.payUrl">复制支付链接</el-button>
                    <el-button class="xq-btn" :class="{'disabled':item.orderId?true:false}" @click="copyEntryLink(item)" type="text" v-else-if="!item.orderId">复制代投链接</el-button>
                  </div>
                </el-col>
              </el-row>
            </div>
          </div>
        </div>
        <div class="empty" v-if="orderList.length==0">
          <p>
            <img src="@static/images/no_msg.png" style="width:290px" />
          </p>
          <p><span>暂无数据</span></p>
        </div>
      </div>
      <el-pagination background v-if="orderList.length!=0" @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageNum" :page-sizes="[10, 20, 30, 40]" :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper" :total="total">
      </el-pagination>
    </div>
  </div>
</template>
<script>
import tooltip from "@/components/tooltip";
import headBox from '@/components/head.vue';
import topSearchForm from '@/components/topSearchForm.vue';
export default {
  data: () => ({
    activeName:'1',
    loading:false,
    pageNum:1,
    pageSize:10,
    total:0,
    selectList:[],// 出单机构/员工列表
    deptList:[], // 部门列表
    orderForm: {
      dateTime: [],
      productName: '',
      orderUniqueKey: '',
      insuranceType: '1',
      name: '',
      orderQueryStatus:'1',
      orderSourceMechanId:'',
      level:'2', // 2出单机构，3出单员工
      departmentId:'',
    },
    orderKind:'',
    orderList:[],
    cascaderProps: {
      checkStrictly: true, //是否严格的遵守父子节点不互相关联
      value: 'deptId', //指定选项的值为选项对象的某个属性值
      label: 'deptmantName', //指定选项标签为选项对象的某个属性值
      emitPath: false, //在选中节点改变时，是否返回由该节点所在的各级菜单的值所组成的数组，若设置 false，则只返回该节点的值
    },
  }),
  components: {
    headBox,
    topSearchForm,
    tooltip
  },
  computed:{
    fullName(){
      return (item)=>{return `${item.policyerName||'-'}/${item.insuranceName||'-'}`}
    }
  },
  created() {
    this.userinfo = this.$tools.getLocal("userinfo");
    if(this.userinfo.level!=3){
      this.getDeptList() // 获取部门列表
    }
    if(this.userinfo.level==1){
      // 一级机构默认出单机构
      this.orderForm.level='2'
      this.getChildList()// 获取出单机构列表
    }else if(this.userinfo.level==2){
      //二级机构没有出单机构，默认出单员工
      this.orderForm.level='3'
      this.getChildList()// 获取出单员工列表
    }
    let begin = new Date()
    let end = new Date()
    begin = begin.getTime() - 29 * 24 * 3600 * 1000
    let timeArr = []
    timeArr[0] = this.$tools.formatDate(begin) + ' ' + '00:00:00'
    timeArr[1] = this.$tools.formatDate(end) + ' ' + '23:59:59'
    this.orderForm.dateTime = timeArr
    this.queryList()
  },
  methods: {
    // 获取部门列表
    getDeptList() {
      this.$http({
        url: '/master/mechanDept/deptSelectTree',
        type: 'PUT',
        params: {},
      }).then((res) => {
        this.deptList = this.handleDeptTree(res.data)
      })
    },
    // 处理为空的children，el-cascader为空的数组会展示暂无数据
    handleDeptTree(data){
     let val = data.map(item=>{
        if(item.children.length==0){
          item.children=''
        }else{
          this.handleDeptTree(item.children)
        }
        return item
      })
      return val
    },
    // 获取机构/员工列表
    getChildList(){
      let param = {
        level:this.orderForm.level,
      }
      // 选中出单机构这个才传值
      if(this.orderForm.level==2){
        param.includeFirst='1'
      }
      this.$http({
        url:'/master/mechan/queryChildList',
        type:'PUT',
        params:param,
      }).then(res=>{
        if(res.httpCode==200){
          this.selectList=res.data
        }
      }).catch(e=>{})
    },
    // 查询列表
    queryList() {
      let param = {
        productName:this.orderForm.productName, // 产品名称
        policyerKey:this.orderForm.insuranceType==1?this.orderForm.name:'', // 投保人名称
        insuranceKey:this.orderForm.insuranceType==2?this.orderForm.name:'', // 被保人名称
        orderUniqueKey:this.orderForm.orderUniqueKey, // 订单id
        startTime:this.orderForm.dateTime.length!=0?this.orderForm.dateTime[0]:'', // 开始日期
        endTime:this.orderForm.dateTime.length!=0?this.orderForm.dateTime[1]:'', // 结束日期
        pageSize:this.pageSize, // 分页条数
        pageNum:this.pageNum, // 页码
        asc:'', // 是否升序排列
        orderBy:'', // 排列字段
        orderKind:this.orderKind,
        orderSourceMechanId:this.orderForm.orderSourceMechanId, // 出单机构/员工id
        orderQueryStatus:this.orderForm.orderQueryStatus,
        departmentId:this.orderForm.departmentId?this.orderForm.departmentId:"",// 所属部门
      }
      // 去除无效参数
      for (const key in param) {
        if (Object.hasOwnProperty.call(param, key)) {
          const element = param[key];
          if(!element){delete param[key]}
        }
      }
      this.loading=true
      this.$http({
        url:"/master/order/selectImportOrders",
        type:"PUT",
        params:param
      }).then(res=>{
        this.loading=false
        this.orderList=res.data
        this.total = res.total
      }).catch(e=>{
        this.loading=false
      })
    },
    // 切换tab
    handlePaneClick(tab){
      this.orderKind = tab.name
      this.search()
    },
    search(){
      this.pageNum=1
      this.queryList()
    },
    // 改变页码
    handleSizeChange(val){
      this.pageSize=val
      this.queryList()
    },
    // 改变页面时
    handleCurrentChange(val){
      this.pageNum=val
      this.queryList()
    },
    // 跳转详情页
    getDetail(item) {
      // 生成了订单跳转详情页，未生成订单跳转录单页面
      if(item.orderId){
        this.$router.push({
          path: "/order_tbd_detail",
          query: {
            orderId: item.orderId,
            mechanShortName:item.showName, // 机构名称
            auditOrder: item.auditOrder, // 是否人核单，1人核单
            policyNo: item.policyNo, // 保单号
            mechanLevel:item.level, // 账号等级，1一级机构，2二级机构，3员工
          },
        });
      }else{
        // 正式环境跳转正式地址，其他跳转测试地址
        let url = `${location.origin}/m/product/premium_assist?key=${item.orderNo}`
        window.open(url,'_blank')
      }
    },
    copyPayUrl(url){
      this.$tools.copyUrl(url)
    },
    // 复制代投链接
    copyEntryLink(item){
      let url = `${location.origin}/m/product/premium_assist?key=${item.orderNo}`
      // 转换短链接
      this.getShortLink(url)
    },
    getShortLink(url) {
      this.$http({
        url: "/bplatTool/transformLongUrl",
        type: "put",
        params: {
          url: encodeURIComponent(url)
        }
      }).then(res => {
        this.$tools.copyUrl(res.data)
      });
    },
  },
  filters:{
    filterNull(val) {
      if (val == "" || val == null) {
        return "-";
      }
      return val;
    },
    filterOrderStatus(val) {
      if(!val){
        return '-'
      }
      if (val == "1") {
        return "未支付";
      } else if (val == "2" || val == "9") {
        return "已支付";
      } else if (val == "3") {
        return "已退款";
      } else if (val == "5" || val == "6") {
        return "已关闭";
      } else if (val == "7") {
        return "未支付-人核中";
      } else if (val == "4") {
        return "未支付-核保失败";
      } else if (val == "8") {
        return "未支付-已撤单";
      } else if (val == "-9") {
        return "未支付-扣款失败";
      } else if (val == "0") {
        return "未核保";
      }
    },
  }
}
</script>
<style lang='scss' scoped>
@import './order_lrd.scss';
</style>